// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"f90ce909","923":"4ac8b889"}[chunkId] + ".chunk.js";
};